"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationSuccessOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var ButtonLink_1 = require("../components/ButtonLink");
var CancellationSuccessOutputWidget = /** @class */ (function (_super) {
    __extends(CancellationSuccessOutputWidget, _super);
    function CancellationSuccessOutputWidget(props) {
        return _super.call(this, props) || this;
    }
    CancellationSuccessOutputWidget.prototype.render = function () {
        var cancelledBeforeStart = this.props.interaction.uistate && this.props.interaction.uistate.cancelledBeforeStart;
        var productsWording = this.pickWordingForCancelledProduct();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "panel" },
                React.createElement("img", { className: "purchase-success-icon d-block mx-auto mb-4", src: "/img/check-mark-big.svg", alt: "" }),
                React.createElement("h1", { className: "text-center text-blue-1" }, "Your Flow subscriptions has been cancelled"),
                !cancelledBeforeStart && React.createElement("p", null,
                    "Until then you are still covered. When your subscriptions expires, you\u2019ll still be able to re-subscribe to your Flow ",
                    productsWording[0],
                    "insurance ",
                    productsWording[1],
                    "."),
                cancelledBeforeStart && React.createElement("p", { className: "mb-0" },
                    React.createElement("strong", null,
                        "You`ll still be able to re-subscribe to your Flow ",
                        productsWording[0],
                        productsWording[1],
                        " in future.")),
                React.createElement("h1", { className: "text-center text-blue-1 pt-3" }, "Flow monthly insurance"),
                React.createElement("ul", { className: "list-unstyled font-family-display bullet-points with-separator" },
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" },
                                React.createElement("span", { className: "font-weight-bold" }, "Flexible"),
                                " \u2013 simple monthly payments"))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" },
                                React.createElement("span", { className: "font-weight-bold" }, "No cancellation"),
                                " or admin fees"))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" },
                                React.createElement("span", { className: "font-weight-bold" }, "Guaranteed maximum price"),
                                " every three months")))),
                !cancelledBeforeStart && React.createElement("img", { className: "mb-3", src: "/img/divider-line.svg", alt: "" }),
                !cancelledBeforeStart && React.createElement("p", null,
                    React.createElement("strong", null,
                        "If you change your mind you can reactivate your Flow ",
                        productsWording[0],
                        productsWording[2])),
                !cancelledBeforeStart && this.renderReactivateButton())));
    };
    CancellationSuccessOutputWidget.prototype.renderReactivateButton = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement(ButtonLink_1.ButtonLink, { id: "reactivateRentersCover", btnClassName: "btn btn-primary btn-next mb-3", to: "/journey/show/product/FlowSubscription/process/mtaReinstateSubscription" }, "Reactivate"))));
    };
    CancellationSuccessOutputWidget.prototype.pickWordingForCancelledProduct = function () {
        var interaction = this.props.interaction;
        if (interaction.uistate.productsForCancellation.length === 2) {
            return ["Car and Renters ", "covers", "subscriptions"];
        }
        else if (interaction.uistate.productsForCancellation.length === 1) {
            if (interaction.uistate.productsForCancellation[0] === services_1.PRODUCT_MOTOR) {
                return ["Car ", "cover", "subscription"];
            }
            else if (interaction.uistate.productsForCancellation[0] === services_1.PRODUCT_RENTERS) {
                return ["Renters ", "cover", "subscription"];
            }
        }
        return [];
    };
    return CancellationSuccessOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.CancellationSuccessOutputWidget = CancellationSuccessOutputWidget;
//# sourceMappingURL=CancellationSuccessOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CancellationSuccessOutputWidget.js
// module id = 3497
// module chunks = 0